import React, { useEffect, useState } from "react";
import { useStripe, PaymentRequestButtonElement } from "@stripe/react-stripe-js";
const GooglePayCheckoutForm = ({ amount }) => {
  const stripe = useStripe();
  const [paymentRequest, setPaymentRequest] = useState(null);
  const [googlePaySupported, setGooglePaySupported] = useState(false);
  useEffect(() => {
    if (!stripe) return;
    const pr = stripe.paymentRequest({
      country: "US",
      currency: "usd",
      total: {
        label: "Total Amount",
        amount: amount * 100,
      },
      requestPayerName: true,
      requestPayerEmail: true,
      supportedPaymentMethods: [
        {
          supportedMethods: "google-pay",
          data: {
            environment: "TEST", // Use "PRODUCTION" for live mode
            apiVersion: 2,
            apiVersionMinor: 0,
            merchantInfo: {
              merchantName: "Grati, LLC", // Replace with your business name
              merchantId: "BCR2DN4TQPP5TEQW", // Your Google Pay Merchant ID
            },
            allowedPaymentMethods: [
              {
                type: "CARD",
                parameters: {
                  allowedAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
                  allowedCardNetworks: ["VISA", "MASTERCARD"],
                },
                tokenizationSpecification: {
                  type: "PAYMENT_GATEWAY",
                  parameters: {
                    gateway: "stripe",
                    "stripe:version": "2020-08-27",
                  },
                },
              },
            ],
          },
        },
      ],
    });
    pr.canMakePayment()
      .then((result) => {
        if (result) {
          setPaymentRequest(pr);
          setGooglePaySupported(true);
        } else {
          console.warn("Google Pay is not available on this device or browser.");
        }
      })
      .catch((error) => {
        console.error("Error checking Google Pay availability:", error);
      });
    pr.on("paymentmethod", async (event) => {
      try {
        const { error } = await stripe.confirmPayment({
          payment_method: event.paymentMethod.id,
          confirmParams: {
            return_url: "https://your-success-url.com", // Replace with your success URL
          },
        });
        if (error) {
          event.complete("fail");
          console.error("Payment failed:", error.message);
        } else {
          event.complete("success");
          console.log("Payment succeeded!");
        }
      } catch (error) {
        event.complete("fail");
        console.error("Payment confirmation error:", error);
      }
    });
  }, [stripe, amount]);
  const handleButtonClick = () => {
    if (paymentRequest && googlePaySupported) {
      paymentRequest
        .show()
        .catch((error) => console.error("Error showing Google Pay wallet:", error));
    }
  };
  return (
    <div>
      {googlePaySupported && paymentRequest ? (
        <div>
          <button
            onClick={handleButtonClick}
            style={{
              margin: "10px 0",
              padding: "12px 20px",
              backgroundColor: "#5A9",
              color: "white",
              border: "none",
              borderRadius: "5px",
              fontSize: "16px",
              cursor: paymentRequest ? "pointer" : "not-allowed",
            }}
          >
            Pay with Google Pay
          </button>
        </div>
      ) : (
        <p>Google Pay is not supported on this device or browser.</p>
      )}
    </div>
  );
};
export default GooglePayCheckoutForm;